const getEarliestTeamConversation = ({
	isDirectMessage,
	teamConversations,
}) => {
	const conversationsToCheck = isDirectMessage
		? teamConversations.filter(
				(conversation) => conversation.isDirectMessage
		  )
		: // every channel is loaded up front, so they don't set where paging starts
		  teamConversations.filter(
				(conversation) =>
					!conversation.isDirectMessage && !conversation.channel
		  );

	if (conversationsToCheck.length === 0) {
		return null; // Return a default date if no conversations match the criteria
	}

	const earliestConversation = conversationsToCheck.reduce(
		(earliest, conversation) =>
			new Date(conversation.latestMessageDate) <
			new Date(earliest.latestMessageDate)
				? conversation
				: earliest,
		conversationsToCheck[0] // Initialize with the first conversation
	);

	return earliestConversation;
};

export default getEarliestTeamConversation;
